import { getBrandsSubscriptionsService } from 'owa-brands-subscription';
import GetBrandsSubscriptionsServiceResponse from '../schema/GetBrandsSubscriptionsServiceResponse';

let subscriptionsCache = null;

function setSubscriptionCache(response: GetBrandsSubscriptionsServiceResponse) {
    subscriptionsCache = {
        ...response,
    };
}

function getSubscriptionFromCache(smtpAddress: string) {
    if (smtpAddress && subscriptionsCache) {
        let smtpAddressBrandSubscription = null;
        [smtpAddressBrandSubscription] = subscriptionsCache.subscriptions.filter(
            elem =>
                elem &&
                elem.smtpInfo &&
                elem.smtpInfo.smtpAddress &&
                elem.smtpInfo.smtpAddress.toLowerCase() === smtpAddress.toLowerCase()
        );
        return smtpAddressBrandSubscription;
    }
}

function unsubscribeFromCache(smtpIdentifier: string) {
    if (subscriptionsCache) {
        let itemIndex;
        const [item] = subscriptionsCache.subscriptions.filter((elem, index) => {
            if (elem && elem.smtpInfo && elem.smtpInfo.smtpIdentifier === smtpIdentifier) {
                itemIndex = index;
                return true;
            }
            return false;
        });

        if (item) {
            subscriptionsCache.subscriptions.splice(itemIndex, 1);
            subscriptionsCache.unsubscribedSubscriptions.push(item);
        } else {
            // If there is no item in Cache, maybe it got stale so reload the Cache
            getBrandsSubscriptionsService();
        }
    }
}

export { setSubscriptionCache, unsubscribeFromCache, getSubscriptionFromCache };
